import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import useTopMessagesOptions from './useTopMessagesOptions';
import useMessageOptions from './useMessageOptions';
import CommonDropdown from '../../../../../../components/common-dropdown/CommonDropdown';
import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import MultiselectDropdownNew from '../../../../../../components/multiselect-dropdown/MultiselectDropdownNew';
import SelectedOptionsList from '../../../../selected-options-list/SelectedOptionsList';

import scss from './HeadToHeadFilters.module.scss';

function HeadToHeadFilters({ topMessage, selectedMessages, onSelectMessage, onChangeTopMessage }) {
  const { t } = useTranslation('resonance');

  const topMessagesOption = useTopMessagesOptions();
  const messageOptions = useMessageOptions({
    disabledIds: selectedMessages.map(({ value }) => value),
  });

  const handleSelectTopMessage = (value) => {
    const selectedMessage = getSelectedMessage(value, topMessagesOption);
    onChangeTopMessage(selectedMessage);
  };

  const handleRemoveMessage = (messageValue) => {
    const newMessages = selectedMessages.filter(({ value }) => value !== messageValue);
    onSelectMessage(newMessages);
  };

  const handleSelectMessage = (value) => {
    onSelectMessage(value);
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.section}>
        <WithLabel label={`${t('topNumberMessages', { number: 10 })}:`} variant={LABEL_STYLES.ROW} isBold>
          <CommonDropdown
            options={topMessagesOption}
            value={topMessage?.value}
            onSelect={handleSelectTopMessage}
            maxWidth={300}
            isFilterable
            name='head-to-head-top-messages'
          />
        </WithLabel>
      </div>

      <div className={clsx(scss.section, scss.sectionMessages)}>
        <WithLabel
          label={`${t('messages')}:`}
          variant={LABEL_STYLES.CUSTOM}
          isBold
          extraClassName={scss.messagesWrapper}>
          <MultiselectDropdownNew
            value={selectedMessages}
            options={messageOptions}
            onChange={handleSelectMessage}
            placeholder={t('selectMessage')}
            name='head-to-head-messages'
            disableNewOptions
            disableSelectedOptionsRender
          />

          <SelectedOptionsList selectedOptions={selectedMessages} onRemoveOption={handleRemoveMessage} />
        </WithLabel>
      </div>
    </div>
  );
}

export default HeadToHeadFilters;

const getSelectedMessage = (messageId, options) => {
  return options.find(({ value }) => value === messageId) || null;
};
